var _path, _mask, _path2, _path3, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgO3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 105,
    viewBox: "0 0 70 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1026 56.2462C31.1379 56.2462 27.1358 55.4103 24.0961 53.7385C21.0565 52.0161 18.8274 49.1285 17.409 45.0756C16.0411 40.9721 15.3572 35.3488 15.3572 28.2057C15.3572 21.0626 16.0411 15.4646 17.409 11.4118C18.8274 7.3083 21.0565 4.42066 24.0961 2.74887C27.1358 1.02642 31.1379 0.16519 36.1026 0.16519C41.0674 0.16519 45.0695 1.02642 48.1092 2.74887C51.1488 4.42066 53.3525 7.3083 54.7203 11.4118C56.1388 15.4646 56.8481 21.0626 56.8481 28.2057C56.8481 35.3488 56.1388 40.9721 54.7203 45.0756C53.3525 49.1285 51.1488 52.0161 48.1092 53.7385C45.0695 55.4103 41.0674 56.2462 36.1026 56.2462ZM40.89 28.0537C40.89 23.6969 40.7381 20.3787 40.4341 18.099C40.1808 15.7686 39.6995 14.1728 38.9903 13.3116C38.3317 12.3997 37.3692 11.9437 36.1026 11.9437C34.8868 11.9437 33.9242 12.3997 33.215 13.3116C32.5058 14.1728 31.9991 15.7686 31.6952 18.099C31.4419 20.3787 31.3152 23.6969 31.3152 28.0537C31.3152 32.3599 31.4419 35.7034 31.6952 38.0845C31.9991 40.4655 32.5058 42.1373 33.215 43.0999C33.9242 44.0118 34.8868 44.4677 36.1026 44.4677C37.3692 44.4677 38.3317 44.0118 38.9903 43.0999C39.6995 42.1373 40.1808 40.4655 40.4341 38.0845C40.7381 35.7034 40.89 32.3599 40.89 28.0537Z",
    fill: "url(#paint0_linear_1374_3842)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1374_3842",
    maskUnits: "userSpaceOnUse",
    x: 48.4072,
    y: 39,
    width: 21,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 48.4072,
    y: 39,
    width: 21,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.653 64.485C56.2302 64.485 54.8613 64.3665 53.5463 64.1293C52.2528 63.8922 51.1426 63.5365 50.2156 63.0622V58.5351C52.393 59.5268 54.5918 60.0226 56.8123 60.0226C59.8088 60.0226 61.307 59.128 61.307 57.3387C61.307 56.4333 60.9405 55.7866 60.2076 55.3985C59.4746 54.9889 58.3321 54.7841 56.7799 54.7841H53.6433V50.4187H56.6506C57.9225 50.4187 58.9034 50.2031 59.5932 49.772C60.3046 49.3408 60.6603 48.7049 60.6603 47.8641C60.6603 47.0665 60.3477 46.4521 59.7225 46.021C59.0974 45.5898 58.2135 45.3742 57.071 45.3742C54.7212 45.3742 52.587 45.9778 50.6683 47.1851V42.561C51.6384 42.0436 52.7487 41.6448 53.999 41.3645C55.2493 41.0627 56.5428 40.9118 57.8794 40.9118C60.8328 40.9118 63.0101 41.5046 64.4113 42.6903C65.8126 43.8544 66.5132 45.5036 66.5132 47.6378C66.5132 48.6079 66.2761 49.5241 65.8018 50.3864C65.3491 51.2487 64.67 51.9816 63.7646 52.5852C66.0281 53.5769 67.1599 55.2584 67.1599 57.6297C67.1599 59.807 66.4162 61.4993 64.9287 62.7065C63.4412 63.8922 61.016 64.485 57.653 64.485Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.653 64.485C56.2302 64.485 54.8613 64.3665 53.5463 64.1293C52.2528 63.8922 51.1426 63.5365 50.2156 63.0622V58.5351C52.393 59.5268 54.5918 60.0226 56.8123 60.0226C59.8088 60.0226 61.307 59.128 61.307 57.3387C61.307 56.4333 60.9405 55.7866 60.2076 55.3985C59.4746 54.9889 58.3321 54.7841 56.7799 54.7841H53.6433V50.4187H56.6506C57.9225 50.4187 58.9034 50.2031 59.5932 49.772C60.3046 49.3408 60.6603 48.7049 60.6603 47.8641C60.6603 47.0665 60.3477 46.4521 59.7225 46.021C59.0974 45.5898 58.2135 45.3742 57.071 45.3742C54.7212 45.3742 52.587 45.9778 50.6683 47.1851V42.561C51.6384 42.0436 52.7487 41.6448 53.999 41.3645C55.2493 41.0627 56.5428 40.9118 57.8794 40.9118C60.8328 40.9118 63.0101 41.5046 64.4113 42.6903C65.8126 43.8544 66.5132 45.5036 66.5132 47.6378C66.5132 48.6079 66.2761 49.5241 65.8018 50.3864C65.3491 51.2487 64.67 51.9816 63.7646 52.5852C66.0281 53.5769 67.1599 55.2584 67.1599 57.6297C67.1599 59.807 66.4162 61.4993 64.9287 62.7065C63.4412 63.8922 61.016 64.485 57.653 64.485Z",
    fill: "url(#paint1_linear_1374_3842)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5463 64.1293L53.2547 65.7197L53.2594 65.7205L53.5463 64.1293ZM50.2156 63.0622H48.5988C48.5988 63.6693 48.9388 64.2251 49.4792 64.5016L50.2156 63.0622ZM50.2156 58.5351L50.8858 57.0637C50.3853 56.8358 49.8033 56.8779 49.3408 57.1754C48.8783 57.473 48.5988 57.9852 48.5988 58.5351H50.2156ZM60.2076 55.3985L59.4189 56.8099C59.4295 56.8159 59.4403 56.8217 59.4511 56.8274L60.2076 55.3985ZM53.6433 54.7841H52.0265C52.0265 55.6771 52.7504 56.4009 53.6433 56.4009V54.7841ZM53.6433 50.4187V48.8019C52.7504 48.8019 52.0265 49.5258 52.0265 50.4187H53.6433ZM59.5932 49.772L58.7552 48.3893C58.7489 48.3931 58.7426 48.397 58.7363 48.4009L59.5932 49.772ZM59.7225 46.021L60.6405 44.69H60.6405L59.7225 46.021ZM50.6683 47.1851H49.0515C49.0515 47.7737 49.3714 48.3158 49.8867 48.6004C50.402 48.885 51.0312 48.867 51.5294 48.5535L50.6683 47.1851ZM50.6683 42.561L49.9075 41.1343C49.3806 41.4153 49.0515 41.9638 49.0515 42.561H50.6683ZM53.999 41.3645L54.3526 42.9422C54.3612 42.9403 54.3698 42.9383 54.3784 42.9362L53.999 41.3645ZM64.4113 42.6903L63.3669 43.9246C63.3707 43.9277 63.3744 43.9308 63.3781 43.9339L64.4113 42.6903ZM65.8018 50.3864L64.3851 49.6072C64.3801 49.6164 64.3751 49.6256 64.3703 49.6348L65.8018 50.3864ZM63.7646 52.5852L62.8677 51.24C62.376 51.5678 62.1023 52.1379 62.154 52.7266C62.2056 53.3154 62.5745 53.829 63.1158 54.0662L63.7646 52.5852ZM64.9287 62.7065L65.9365 63.9709C65.9402 63.9679 65.9439 63.9649 65.9476 63.9619L64.9287 62.7065ZM57.653 62.8682C56.3203 62.8682 55.0477 62.7572 53.8332 62.5382L53.2594 65.7205C54.6749 65.9758 56.1402 66.1019 57.653 66.1019V62.8682ZM53.8378 62.539C52.6606 62.3232 51.7077 62.0095 50.9521 61.6229L49.4792 64.5016C50.5775 65.0635 51.8451 65.4612 53.2547 65.7197L53.8378 62.539ZM51.8325 63.0622V58.5351H48.5988V63.0622H51.8325ZM49.5455 60.0065C51.9167 61.0865 54.3431 61.6394 56.8123 61.6394V58.4058C54.8406 58.4058 52.8692 57.9671 50.8858 57.0637L49.5455 60.0065ZM56.8123 61.6394C58.4186 61.6394 59.8915 61.409 61.0122 60.7398C62.2651 59.9917 62.9238 58.7848 62.9238 57.3387H59.6902C59.6902 57.6819 59.5999 57.8169 59.3544 57.9635C58.9769 58.1889 58.2024 58.4058 56.8123 58.4058V61.6394ZM62.9238 57.3387C62.9238 56.6672 62.7869 55.9917 62.4388 55.3775C62.0864 54.7555 61.5705 54.2907 60.9641 53.9696L59.4511 56.8274C59.5776 56.8944 59.6115 56.947 59.6255 56.9717C59.6439 57.0042 59.6902 57.1048 59.6902 57.3387H62.9238ZM60.9963 53.9871C59.8942 53.3713 58.4103 53.1673 56.7799 53.1673V56.4009C58.2539 56.4009 59.055 56.6066 59.4189 56.8099L60.9963 53.9871ZM56.7799 53.1673H53.6433V56.4009H56.7799V53.1673ZM55.2601 54.7841V50.4187H52.0265V54.7841H55.2601ZM53.6433 52.0355H56.6506V48.8019H53.6433V52.0355ZM56.6506 52.0355C58.0689 52.0355 59.3968 51.8014 60.4501 51.143L58.7363 48.4009C58.4099 48.6049 57.7761 48.8019 56.6506 48.8019V52.0355ZM60.4312 51.1547C61.6324 50.4267 62.2771 49.2628 62.2771 47.8641H59.0435C59.0435 48.1469 58.9768 48.255 58.7552 48.3893L60.4312 51.1547ZM62.2771 47.8641C62.2771 46.5667 61.7287 45.4405 60.6405 44.69L58.8046 47.3519C58.9667 47.4637 59.0435 47.5663 59.0435 47.8641H62.2771ZM60.6405 44.69C59.6407 44.0005 58.3858 43.7574 57.071 43.7574V46.991C58.0412 46.991 58.554 47.1791 58.8046 47.3519L60.6405 44.69ZM57.071 43.7574C54.4282 43.7574 51.9936 44.441 49.8073 45.8166L51.5294 48.5535C53.1804 47.5147 55.0141 46.991 57.071 46.991V43.7574ZM52.2852 47.1851V42.561H49.0515V47.1851H52.2852ZM51.4292 43.9876C52.2518 43.5488 53.2214 43.1957 54.3526 42.9422L53.6454 39.7868C52.2759 40.0938 51.025 40.5383 49.9075 41.1343L51.4292 43.9876ZM54.3784 42.9362C55.4997 42.6655 56.6656 42.5286 57.8794 42.5286V39.295C56.42 39.295 54.999 39.4599 53.6196 39.7928L54.3784 42.9362ZM57.8794 42.5286C60.6687 42.5286 62.3895 43.0975 63.3669 43.9246L65.4557 41.456C63.6306 39.9117 60.9968 39.295 57.8794 39.295V42.5286ZM63.3781 43.9339C64.3445 44.7367 64.8964 45.8926 64.8964 47.6378H68.13C68.13 45.1146 67.2807 42.9721 65.4445 41.4467L63.3781 43.9339ZM64.8964 47.6378C64.8964 48.3313 64.7301 48.98 64.3851 49.6072L67.2185 51.1655C67.822 50.0681 68.13 48.8844 68.13 47.6378H64.8964ZM64.3703 49.6348C64.0575 50.2305 63.5749 50.7685 62.8677 51.24L64.6614 53.9305C65.7651 53.1948 66.6407 52.2668 67.2333 51.1379L64.3703 49.6348ZM63.1158 54.0662C64.0285 54.466 64.6094 54.9575 64.9698 55.4929C65.3272 56.0239 65.5431 56.7097 65.5431 57.6297H68.7767C68.7767 56.1784 68.4268 54.8378 67.6524 53.6873C66.881 52.5413 65.7643 51.6961 64.4134 51.1043L63.1158 54.0662ZM65.5431 57.6297C65.5431 59.3948 64.9644 60.5953 63.9098 61.4511L65.9476 63.9619C67.8679 62.4034 68.7767 60.2192 68.7767 57.6297H65.5431ZM63.9209 61.4422C62.8684 62.2812 60.901 62.8682 57.653 62.8682V66.1019C61.131 66.1019 64.0141 65.5032 65.9365 63.9709L63.9209 61.4422Z",
    fill: "white",
    mask: "url(#path-2-outside-1_1374_3842)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2205,
    cy: 12.3181,
    r: 10.5093,
    fill: "url(#paint2_linear_1374_3842)",
    stroke: "white",
    strokeWidth: 1.61682
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_1374_3842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.0829,
    cy: 58.3507,
    r: 5.65887,
    transform: "rotate(50.5241 42.0829 58.3507)",
    fill: "url(#paint3_linear_1374_3842)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_d_1374_3842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.4193,
    cy: 52.9187,
    r: 2.42523,
    transform: "rotate(50.5241 33.4193 52.9187)",
    fill: "url(#paint4_linear_1374_3842)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter2_d_1374_3842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.8692,
    cy: 58.6079,
    r: 1.61682,
    transform: "rotate(50.5241 32.8692 58.6079)",
    fill: "url(#paint5_linear_1374_3842)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter3_f_1374_3842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.2997,
    cy: 8.27606,
    r: 2.42523,
    fill: "url(#paint6_linear_1374_3842)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter4_f_1374_3842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.3419,
    cy: 12.318,
    r: 1.61682,
    fill: "url(#paint7_linear_1374_3842)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter5_f_1374_3842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.5335,
    cy: 21.2108,
    r: 4.04205,
    fill: "url(#paint8_linear_1374_3842)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter6_d_1374_3842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.6035,
    cy: 41.4209,
    r: 3.23364,
    fill: "url(#paint9_linear_1374_3842)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter7_d_1374_3842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.36999,
    cy: 43.0377,
    r: 1.61682,
    fill: "url(#paint10_linear_1374_3842)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1374_3842",
    x: 34.807,
    y: 52.6917,
    width: 14.5518,
    height: 14.5518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.80841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1374_3842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1374_3842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1374_3842",
    x: 29.3773,
    y: 50.4934,
    width: 8.08423,
    height: 8.08423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.80841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1374_3842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1374_3842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1374_3842",
    x: 29.6356,
    y: 56.991,
    width: 6.46728,
    height: 6.46753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.80841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1374_3842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1374_3842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1374_3842",
    x: 54.2577,
    y: 4.23401,
    width: 8.08398,
    height: 8.08398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.80841,
    result: "effect1_foregroundBlur_1374_3842"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1374_3842",
    x: 59.1083,
    y: 9.08435,
    width: 6.46728,
    height: 6.46728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.80841,
    result: "effect1_foregroundBlur_1374_3842"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1374_3842",
    x: 53.4494,
    y: 13.1266,
    width: 16.1681,
    height: 16.1681,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02103,
    result: "effect1_foregroundBlur_1374_3842"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1374_3842",
    x: 5.75305,
    y: 38.1873,
    width: 9.70093,
    height: 9.70093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.80841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1374_3842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1374_3842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1374_3842",
    x: 4.13635,
    y: 41.4209,
    width: 6.46728,
    height: 6.46728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.80841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1374_3842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1374_3842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1374_3842",
    x1: 13.8374,
    y1: 30.4568,
    x2: 60.293,
    y2: 59.0358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1374_3842",
    x1: 49.4072,
    y1: 10.75,
    x2: 73.6285,
    y2: 11.8916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1374_3842",
    x1: 2.51953,
    y1: 4.43611,
    x2: 25.7612,
    y2: 10.4321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1374_3842",
    x1: 36.424,
    y1: 53.7529,
    x2: 49.9817,
    y2: 57.2505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1374_3842",
    x1: 30.9941,
    y1: 50.9482,
    x2: 36.8045,
    y2: 52.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1374_3842",
    x1: 31.2524,
    y1: 57.2943,
    x2: 35.126,
    y2: 58.2936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1374_3842",
    x1: 55.8745,
    y1: 6.30556,
    x2: 61.6849,
    y2: 7.80455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1374_3842",
    x1: 60.7251,
    y1: 11.0043,
    x2: 64.5987,
    y2: 12.0036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1374_3842",
    x1: 57.4915,
    y1: 17.9266,
    x2: 67.1755,
    y2: 20.4249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1374_3842",
    x1: 7.36987,
    y1: 38.7936,
    x2: 15.1171,
    y2: 40.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1374_3842",
    x1: 5.75317,
    y1: 41.7241,
    x2: 9.62679,
    y2: 42.7234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO3);
export default __webpack_public_path__ + "static/media/O3.398b43d29301b93e8aa017a38be86e26.svg";
export { ForwardRef as ReactComponent };